<template>
    <div style="width: 100vw;height: 100vh;background-color: #E8CE60;overflow-y: auto;font-family: GravityNormal">
        <div class="accountform">
            <div style="display: flex;width: 100%;align-items: flex-start;">
                <div style="display: flex;flex: 1;align-items: flex-start;">
                    <img src="../../assets/image/logo.png" style="width: 240px;height: auto;margin-right: 32px" />
                    <img src="../../assets/image/ifo_logo.png" style="width: auto;height: 60px;margin-top: 10px;" />
                </div>
                <p style="width: 300px;font-size: 12px;text-align: right;color: #666;line-height: 20px;">
                    Extracurricular Activity Excellence (EAE) International stands as a global partner to the International Finance Olympiad (IFO), entrusted with the role of its operation.</p>
            </div>

            <div class="title1">Organization Registration for {{form.project_code}}</div>
            <div class="title1" style="font-size: 12px;margin-top: 5px;">please fill out this form in English</div>
            <div style="color: #ff0000; font-size: 14px; margin: 20px 0; text-align: center; width: 100%; padding: 10px; background-color: #ffe6e6; border-radius: 4px;">
                This registration form is only for ADVISERS/TEACHERS to register for their organizations. <br>If you are <strong>an individual STUDENT or a STUDENT team leader</strong>, please use the<a href="/#/Form/ifo" style="color: #ff0000; text-decoration: underline;"> Student Registration Form</a> instead.
            </div>

            <el-form :model="form" :rules="formRules" ref="form"
                style="width: 100%;padding: 0px 20px;box-sizing: border-box;" label-position="top">

                <p style="text-align: left;color: #E8CE60; font-size: 16px; font-weight: bold;margin: 20px 0px;">
                    Registrant Information</p>

                <div class="row">
                    <div class="item">
                        <el-form-item>
                            <el-form-item label="First Name (in English)" prop="contact_givenName">
                                <el-input v-model="form.contact_givenName" placeholder="Please input"></el-input>
                            </el-form-item>
                        </el-form-item>
                    </div>
                    <div class="item">
                        <el-form-item>
                            <el-form-item label="Last Name (in English)" prop="contact_lastName">
                                <el-input v-model="form.contact_lastName" placeholder="Please input"></el-input>
                            </el-form-item>
                        </el-form-item>
                    </div>
                </div>

                <div class="row">
                    <div class="item">
                        <el-form-item label="Title" prop="contact_prefix">
                            <el-select v-model="form.contact_prefix" placeholder="Please select" style="width: 100%;">
                                <el-option value="Mr.">Mr.</el-option>
                                <el-option value="Mrs.">Mrs.</el-option>
                                <el-option value="Ms.">Ms.</el-option>
                                <el-option value="Dr.">Dr.</el-option>
                                <el-option value="Prof.">Prof.</el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="item">
                        <el-form-item label="Position" prop="contact_position">
                            <el-input v-model="form.contact_position" placeholder="Please input"></el-input>
                        </el-form-item>
                    </div>
                </div>

                <div class="row">
                    <div class="item">
                        <el-form-item label="Email" prop="contact_email">
                            <el-input v-model="form.contact_email" placeholder="Please input"></el-input>
                        </el-form-item>
                    </div>
                    <div class="item">
                        <el-form-item label="School Name (EN)" prop="account_nameEn">
                            <el-input v-model="form.account_nameEn" placeholder="Please input"></el-input>
                        </el-form-item>
                    </div>
                </div>

                <div class="row">
                    <div class="item">
                        <el-form-item label="Organization Type" prop="organization_type">
                            <el-select v-model="form.organization_type" placeholder="Please select" style="width: 100%;">
                                <el-option value="Public School">Public School</el-option>
                                <el-option value="Private School">Private School</el-option>
                                <el-option value="International School">International School</el-option>
                                <el-option value="Educational Institution">Educational Institution</el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="item">
                        <el-form-item label="How did you know about us?" prop="know_sources">
                            <el-select v-model="form.know_sources" multiple placeholder="Please select" style="width: 100%;">
                                <el-option value="Social Media">Social Media</el-option>
                                <el-option value="Search Engine">Search Engine</el-option>
                                <el-option value="Email">Email</el-option>
                                <el-option value="Friend">Friend</el-option>
                                <el-option value="School">School</el-option>
                                <el-option value="Others">Others</el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </div>

                <div class="row">
                    <div class="item">
                        <el-form-item label="Curriculum Type" prop="curriculum_types">
                            <el-select v-model="form.curriculum_types" multiple placeholder="Please select" style="width: 100%;">
                                <el-option value="National Curriculum">National Curriculum</el-option>
                                <el-option value="IB">IB</el-option>
                                <el-option value="A-Level">A-Level</el-option>
                                <el-option value="AP">AP</el-option>
                                <el-option value="Others">Others</el-option>
                            </el-select>
                        </el-form-item>
                        <div v-if="checkShowOthersView()" style="margin-top: 10px;">
                            <el-input v-model="form.other_curriculum_type" placeholder="Please specify other curriculum type"></el-input>
                        </div>
                    </div>
                    <div class="item">
                        <el-form-item label="Annual Tuition" prop="annual_tuition">
                            <el-select v-model="form.annual_tuition" placeholder="Please select" style="width: 100%;">
                                <el-option value="> 11,000 USD">> 11,000 USD</el-option>
                                <el-option value="> 6,000 USD">> 6,000 USD</el-option>
                                <el-option value="> 3,000 USD">> 3,000 USD</el-option>
                                <el-option value="> 1,500 USD">> 1,500 USD</el-option>
                                <el-option value="> 1,100 USD">> 1,100 USD</el-option>
                                <el-option value="> 750 USD">> 750 USD</el-option>
                                <el-option value="> 350 USD">> 350 USD</el-option>
                                <el-option value="< 350 USD and > 0">< 350 USD and > 0</el-option>
                                <el-option value="Free">Free</el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </div>

                <div class="row">
                    <div class="item">
                        <el-form-item label="School's Student Size" prop="student_size">
                            <el-select v-model="form.student_size" placeholder="Please select" style="width: 100%;">
                                <el-option value="0-50 students" label="0-50 students"></el-option>
                                <el-option value="50-100 students" label="50-100 students"></el-option>
                                <el-option value="100-200 students" label="100-200 students"></el-option>
                                <el-option value="200-500 students" label="200-500 students"></el-option>
                                <el-option value="500-1000 students" label="500-1000 students"></el-option>
                                <el-option value="1000-2000 students" label="1000-2000 students"></el-option>
                                <el-option value="above 2000 students" label="Above 2000 students"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="item">
                        <el-form-item prop="account_country">
                            <template slot="label">
                                <span>Country/Region</span>
                                <el-tooltip effect="dark" placement="top" trigger="click" content="Select your school's country/region, regardless of your citizenship. For international students, this means your current school location. Registration levels are based on school location only.">
                                    <i class="el-icon-info" style="margin-left: 5px; color: #409EFF; cursor: pointer;"></i>
                                </el-tooltip>
                            </template>
                            <div>
                                <el-select v-model="form.account_country" style="width: 100%;" placeholder="Please select" filterable @change="handleCountryChanged">
                                    <el-option v-for="(country, index) in countryList" :key="index"
                                        :label="country.country_en" :value="country.country_en"></el-option>
                                </el-select>
                                <p style="color: #666;font-size: 12px;line-height: 16px;margin-top: 10px;">Select your school's country/region, regardless of your citizenship. For international students, this means your current school location. Registration levels are based on school location only.</p>
                            </div>
                        </el-form-item>
                    </div>
                </div>

                <div class="row">
                    <div class="item">
                        <el-form-item label="State/Province" prop="account_province">
                            <el-input v-model="form.account_province" placeholder="Please input"></el-input>
                        </el-form-item>
                    </div>
                </div>

                <div class="row">
                    <div class="item">
                        <el-form-item label="Website" prop="account_website">
                            <el-input v-model="form.account_website" placeholder="Please input"></el-input>
                        </el-form-item>
                    </div>
                    <div class="item">
                        <el-form-item label=" Address" prop="account_address">
                            <el-input v-model="form.account_address" placeholder="Please input"></el-input>
                        </el-form-item>
                    </div>
                </div>

                <!-- Advisor section -->
                <p style="text-align: left;color: #E8CE60; font-size: 16px; font-weight: bold;margin: 20px 0px;">
                    Advisor Information</p>

                <el-form-item label="Will you be the advisor for the IFO Program in your school/institution?" prop="contact_as_adviser">
                    <el-radio v-model="form.contact_as_adviser" label="YES"></el-radio>
                    <el-radio v-model="form.contact_as_adviser" label="NO" style="margin-left: 100px;"></el-radio>
                </el-form-item>

                <template v-if="form.contact_as_adviser === 'NO'">
                    <p style="color: #666; font-size: 14px; line-height: 20px; margin-bottom: 20px;">If you are not the advisor for IFO Program, please provide the information of the right advisor.</p>
                    <div class="row">
                        <div class="item">
                            <el-form-item label="Advisor's First Name" style="flex: 1;" prop="adviser_givenName">
                                <el-input v-model="form.adviser_givenName" placeholder="Please input"></el-input>
                            </el-form-item>
                        </div>
                        <div class="item">
                            <el-form-item label="Advisor's Last Name" style="flex: 1;" prop="adviser_lastName">
                                <el-input v-model="form.adviser_lastName" placeholder="Please input"></el-input>
                            </el-form-item>
                        </div>
                    </div>

                    <div class="row">
                        <div class="item">
                            <el-form-item label="Advisor's Position/Subject" style="flex: 1;" prop="adviser_subject">
                                <el-input v-model="form.adviser_subject" placeholder="Please input"></el-input>
                            </el-form-item>
                        </div>
                        <div class="item">
                            <el-form-item label="Advisor's Email" style="flex: 1;" prop="adviser_email">
                                <el-input v-model="form.adviser_email" placeholder="Please input"></el-input>
                            </el-form-item>
                        </div>
                    </div>
                </template>

                <!-- Agreement section -->
                <div class="terms flex items-center justify-center" style="margin-top: 20px;">
                    <div @click="isAgree = !isAgree" style="display: flex; align-items: center">
                        <img style="width: 16px;height: 16px;cursor: pointer;margin-right: 16px;" v-if="!isAgree"
                            :src="require('../../assets/image/unchecked.png')" />
                        <img style="width: 16px;height: 16px;cursor: pointer;margin-right: 16px;" v-else
                            :src="require('../../assets/image/checked.png')" />
                    </div>
                    <p style="line-height: 20px;"> I have read and agree to the <a href="#/privacy-policy" target="_blank" rel="noopener noreferrer" style="color: #409EFF; text-decoration: underline;" @click.stop>Privacy Policy</a>, and I agree that EAE may use my provided information to set up a personal account and to email me about notifications, reminders, and extracurricular opportunities.</p>
                </div>

                <div v-if="!isRegistrationOpen()" style="color: #E8CE60; font-size: 16px; font-weight: bold;margin: 20px 0px;text-align: center; padding: 20px; background-color: #fff9e6; border-radius: 8px; border: 2px solid #E8CE60;">
                    Registration is not open yet.<br>
                    <span style="font-size: 14px;color: #666; display: block; margin-top: 10px;">Registration will open at {{project.start_date_string}} in your local time.</span>
                    <span style="font-size: 12px;color: #999; display: block; margin-top: 8px;">Please come back later to complete your registration.</span>
                </div>
                <div v-else-if="isDeadlinePassed()" style="color: #E8CE60; font-size: 16px; font-weight: bold;margin: 20px 0px;text-align: center;">
                    The registration deadline has passed.<br>
                    <span style="font-size: 12px;color: #666;">The registration deadline is {{project.deadline_string}} in your local time.</span>
                </div>
                <div v-else class="submit">
                    <div class="submitBtn" @click="submit">Submit</div>
                </div>
            </el-form>
        </div>
        <AccountFormConfirmDialog
            :show.sync="showConfirmDialog"
            :email="form.contact_email"
            :highlightFields="confirmHighlightFields"
            :normalFields="confirmNormalFields"
            :themeColor="'#D3A12A'"
            @confirmed="doSubmit"
        />
    </div>
</template>

<script>
import {
    getCountries,
    saveAccountFormV1,
    postRequest,
    getExclusivePartners
} from '../../api/eae'
import AccountFormConfirmDialog from '../../components/AccountFormConfirmDialog.vue'
import { exclusivePartnersMixin } from '../../utils/exclusivePartners'
import { checkAndConfirmName } from '../../utils/nameValidator'
import '../../assets/common/font.css'

export default ({
    name: 'index',
    components: { AccountFormConfirmDialog },
    mixins: [exclusivePartnersMixin],
    data() {
        return {
            showConfirmDialog: false,
            isAgree: false,
            countryList: [],
            project: {
                deadline_date: '',
                deadline_string: ''
            },
            form: {
                BU: "IFO",
                project_code: "",
                new_field: 'yes',
                account_website:'',
                account_country: '',
                account_name: '',
                account_nameEn: '',
                account_province: '',
                account_address: '',
                organization_type: '',

                curriculum_types: [],
                other_curriculum_type: '',
                annual_tuition: '',
                student_size: '',

                contact_lastName: '',
                contact_givenName: '',
                contact_prefix: '',
                contact_email: '',
                contact_position: '',

                know_sources: [],
                contact_as_adviser: '',

                adviser_lastName: '',
                adviser_givenName: '',
                adviser_subject: '',
                adviser_email: '',
            },
            formRules: {
                account_website: [{ required: true, message: "Please input", trigger: "blur" }],
                annual_tuition: [{ required: true, message: "Please select", trigger: "blur" }],
                curriculum_types: [
                    { required: true, message: "Please select", trigger: "blur" },
                ],
                know_sources: [{ required: true, message: "Please select", trigger: "blur" }],
                contact_lastName: [{ required: true, message: "Please input", trigger: "blur" }],
                contact_givenName: [{ required: true, message: "Please input", trigger: "blur" }],
                contact_prefix: [{ required: true, message: "Please select", trigger: "blur" }],
                contact_email: [
                    { required: true, message: "Please input", trigger: "blur" },
                    { type: 'email', message: "Please enter a valid email address", trigger: "blur" }
                ],
                contact_position: [{ required: true, message: "Please input", trigger: "blur" }],

                account_nameEn: [{ required: true, message: "Please input", trigger: "blur" }],
                organization_type: [{ required: true, message: "Please select", trigger: "blur" }],
                account_country: [{ required: true, message: "Please select", trigger: "blur" }],
                account_province: [{ required: true, message: "Please input", trigger: "blur" }],

                contact_as_adviser: [{ required: true, message: "Please select", trigger: "blur" }],
                adviser_givenName: [{ 
                    required: true, 
                    message: "Please input", 
                    trigger: "blur",
                    validator: (rule, value, callback) => {
                        if (this.form.contact_as_adviser === 'NO' && !value) {
                            callback(new Error('Please input'));
                        } else {
                            callback();
                        }
                    }
                }],
                adviser_lastName: [{ 
                    required: true, 
                    message: "Please input", 
                    trigger: "blur",
                    validator: (rule, value, callback) => {
                        if (this.form.contact_as_adviser === 'NO' && !value) {
                            callback(new Error('Please input'));
                        } else {
                            callback();
                        }
                    }
                }],
                adviser_subject: [{ 
                    required: true, 
                    message: "Please input", 
                    trigger: "blur",
                    validator: (rule, value, callback) => {
                        if (this.form.contact_as_adviser === 'NO' && !value) {
                            callback(new Error('Please input'));
                        } else {
                            callback();
                        }
                    }
                }],
                adviser_email: [
                    { 
                        required: true, 
                        message: "Please input", 
                        trigger: "blur",
                        validator: (rule, value, callback) => {
                            if (this.form.contact_as_adviser === 'NO' && !value) {
                                callback(new Error('Please input'));
                            } else {
                                callback();
                            }
                        }
                    },
                    { type: 'email', message: "Please enter a valid email address", trigger: "blur" }
                ],
                student_size: [
                    { required: true, message: "Please select", trigger: "change" }
                ],
            }
        }
    },
    computed: {
        projectYear() {
            const now = new Date()
            const currentYear = now.getFullYear()
            const currentMonth = now.getMonth() + 1 // 1-12

            // If on or after September 1st, use next year; otherwise use current year
            if (currentMonth >= 9) {
                return currentYear + 1
            } else {
                return currentYear
            }
        },
        confirmHighlightFields() {
            return [
                { label: 'Name', value: (this.form.contact_givenName + ' ' + this.form.contact_lastName).trim() },
                { label: 'Email', value: this.form.contact_email },
                { label: 'Country/Region', value: this.form.account_country }
            ].filter(f => f.value)
        },
        confirmNormalFields() {
            return [
                { label: 'Organization', value: this.form.account_nameEn },
                { label: 'Organization Type', value: this.form.organization_type },
                { label: 'Position', value: this.form.contact_position },
                { label: 'State/Province', value: this.form.account_province },
                { label: 'Website', value: this.form.account_website },
            ].filter(f => f.value)
        }
    },
    mounted() {
        // Set project_code dynamically based on current date
        this.form.project_code = `${this.projectYear}IFO`
        
        this.getProjectInfo()
        this.fetchExclusivePartners(this.form.project_code)
        this.requestCountries()
    },
    methods: {
        handleCountryChanged() {
            this.checkExclusivePartner(this.form.account_country)
        },
        isDeadlinePassed() {
            if (!this.project.deadline_date) {
                return false;
            }
            const currentDate = new Date();
            const deadlineDate = new Date(this.project.deadline_date);
            // Compare dates (year, month, day) only
            const currentDateOnly = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
            const deadlineDateOnly = new Date(deadlineDate.getFullYear(), deadlineDate.getMonth(), deadlineDate.getDate());
            return currentDateOnly > deadlineDateOnly;
        },
        isRegistrationOpen() {
            if (!this.project.start_date) {
                return true; // If no start date, assume registration is open
            }
            const currentTime = new Date().getTime();
            return currentTime >= this.project.start_date;
        },
        checkShowOthersView(){
            return this.form.curriculum_types.includes('Others')
        },

        getProjectInfo() {
            postRequest({
                function: 'getProjectInfoByCode',
                project_code: this.form.project_code
            }).then((res) => {
                this.project = res.data
                // Add 23:59:59 to deadline date
                let deadlineDate = new Date(this.project.deadline_date)
                deadlineDate.setHours(23, 59, 59)
                
                // Convert to UTC+8 time string
                let utc8Date = new Date(deadlineDate.getTime())
                let utc8String = utc8Date.toLocaleString('en-US', { timeZone: 'Asia/Shanghai' })
                
                this.project.deadline_string = utc8String
                // Convert UTC+8 string to local browser time
                this.project.deadline_date = new Date(utc8String).getTime()
                
                // Process start date for registration opening check
                if (this.project.project_progress_start_date) {
                    let startDate = new Date(this.project.project_progress_start_date)
                    // Get the date components in local timezone
                    let year = startDate.getFullYear()
                    let month = startDate.getMonth()
                    let day = startDate.getDate()
                    // Create new date at 00:00:00 in local timezone
                    let localStartDate = new Date(year, month, day, 0, 0, 0, 0)
                    // Format as string in local timezone
                    this.project.start_date_string = localStartDate.toLocaleString('en-US', { 
                        year: 'numeric',
                        month: '2-digit',
                        day: '2-digit',
                        hour: '2-digit',
                        minute: '2-digit',
                        second: '2-digit',
                        hour12: false
                    })
                    this.project.start_date = localStartDate.getTime()
                }
            })
        },

        requestCountries() {
            getCountries().then((res) => {
                this.countryList = res.data
            })
        },

        submit() {
            if (!this.validateExclusivePartnerBeforeSubmit(this.form.account_country)) {
                return
            }
            if (!this.isAgree) {
                this.$message.warning("You must agree to the statement.");
                return;
            }

            // Check if registration is open
            if (!this.isRegistrationOpen()) {
                this.$message.warning("Registration is not open yet. Please come back later.");
                return;
            }

            // Check if past deadline
            if (this.isDeadlinePassed()) {
                this.$message.error("Registration deadline has passed.");
                return;
            }

            this.$refs.form.validate((val) => {
                if (val) {
                    checkAndConfirmName(this, [
                        { first: this.form.contact_givenName, last: this.form.contact_lastName, label: 'Registrant name' }
                    ]).then(() => {
                        this.showConfirmDialog = true
                    }).catch(() => {})
                }
            });
        },
        doSubmit() {
            saveAccountFormV1(this.form).then((res) => {
                if (res) {
                    this.$confirm("Registration received. We'll first manually validate your organization information and then set up your school and advisor accounts. You will receive an email from us within 3-5 business days with further instructions on how to log into our EAE system and enter students (with your organization's exclusive student registration link).", 'Registration Successful', {
                        showCancelButton: false,
                        confirmButtonText: 'OK',
                        type: 'success'
                    })
                }
            });
        }
    }
})
</script>

<style scoped lang="scss">
::-webkit-scrollbar {
    display: none;
}

.accountform {
    width: 1000px;
    margin: 0 auto;
    background: #fff;
    padding: 30px 40px 20px;
    box-sizing: border-box;

    .title1 {
        margin-top: 20px;
        font-family: GravityBold;
        color: #E8CE60;
        font-size: 22px;
        margin-bottom: 10px;
        align-items: center;
        width: 100%;
        font-weight: bold;
        text-align: center;
    }

    .row {
        display: flex;
        justify-content: space-between;

        .item {
            width: 420px;
        }
    }

    .submit {
        .submitBtn {
            font-family: GravityBold;
            width: 280px;
            height: 50px;
            background: #E8CE60;
            border-radius: 25px;
            text-align: center;
            line-height: 50px;
            color: #fff;
            font-size: 20px;
            margin: 0 auto;
            margin-top: 20px;
            cursor: pointer;
        }
        margin-bottom: 50px;
    }
}

/deep/ .el-input__inner {
    height: 36px;
    line-height: 36px;
    border-color: #E8CE60;
}

/deep/ .el-input__inner:hover {
    border-color: #E8CE60;
}

/deep/ .el-input__inner:focus {
    border-color: #E8CE60;
}

/deep/ .el-form-item__label {
    font-size: 16px;
    color: #000000;
}

/deep/ .el-checkbox__label {
    font-size: 16px;
    color: #000000;
    font-weight: normal;
}

/deep/ .el-radio__label {
    font-size: 16px;
    color: #000000;
    font-weight: normal;
}

/deep/ .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #E8CE60;
    border-color: #E8CE60;
}

/deep/ .el-checkbox__input.is-checked+.el-checkbox__label {
    color: #E8CE60;
}

/deep/ .el-radio__input.is-checked .el-radio__inner {
    background-color: #E8CE60;
    border-color: #E8CE60;
}

/deep/ .el-radio__input.is-checked+.el-radio__label {
    color: #E8CE60;
}
</style> 